/** The phone as the apps hold it: international format with the leading `+` (`573…` → `+573…`). */
export function fromApiPhone(phone: string): string {
    return phone.startsWith('+') ? phone : `+${phone}`;
}
